module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cartographies":"Cartographies :","groups":"Groups :","modules":"Modules :","qualificationList":"Qualification list"},"fr":{"cartographies":"Cartographies :","groups":"Groupes :","modules":"Modules :","qualificationList":"Liste des qualifications"}}')
  delete Component.options._Ctor
}
